import React from "react";
import bijouxImage from '../../images/IMG_20250301_154853.png';
import CategoryPage from '../CategoryPage';
import { CATEGORIES_SEO } from '../../seo/pagesSeo';

function LuxeMaroquineriePage() {
    const seo = CATEGORIES_SEO['luxe-maroquinerie'];
    const details = [
        "Hermès – Sacs iconiques comme le Birkin, le Kelly ou le Constance, ainsi que les éditions limitées ou vintage.",
        "Goyard – Réputée pour ses sacs en toile monogrammée et son savoir-faire historique.",
        "Louis Vuitton (anciens modèles) – Sacs vintage, notamment en toile Monogram ou éditions limitées.",
        "Fendi – Sacs emblématiques comme le Baguette ou le Peekaboo, en édition limitée ou vintage.",
        "Chanel (vintage) – Modèles classiques comme le sac 2.55 ou les sacs en cuir matelassé.",
        "Céline (ancien modèle) – Sacs comme le Luggage ou les modèles vintage en cuir.",
        "Delvaux – Maison belge célèbre pour ses sacs luxueux, notamment le Brillant vintage.",
        "Saddle (Dior) – Modèle iconique de Dior, en version vintage.",
        "Lancel – Connu pour ses sacs vintage en cuir et modèles classiques.",
        "Fendi Fur – Créations en fourrure, notamment vestes et accessoires rares.",
        "Stola – Manteaux en fourrure haut de gamme, marquant l’histoire de la mode.",
        "Mink Coat by Kopenhagen Fur – Manteaux en vison de grande qualité.",
        "Louis Vuitton (vintage fourrure) – Accessoires et manteaux en fourrure des collections anciennes.",
        "Chanel (vintage fourrure) – Manteaux et accessoires en fourrure recherchés.",
        "Pierre Balmain – Manteaux en fourrure vintage représentant l’élégance intemporelle.",
    ];

    return (
        <CategoryPage
            title="Luxe, Maroquinerie et Fourrure"
            image={bijouxImage}
            description="En tant qu'expert en maroquinerie de haute couture, je me spécialise dans le rachat de pièces rares et précieuses des plus grandes maisons : Hermès, Louis Vuitton, Chanel, Dior et bien d'autres. Que ce soit des sacs à main, portefeuilles, bagagerie, manteaux de fourrure ou accessoires exclusifs, je vous propose des offres exceptionnelles et des prix compétitifs. Ma maîtrise des matériaux, du cuir à la toile, du crocodile aux peaux exotiques, me permet d'évaluer chaque pièce avec la plus grande rigueur et d'en révéler toute sa valeur."
            details={details}
            seoTitle={seo.title}
            seoDescription={seo.description}
            seoPath={seo.path}
        />
    );
}

export default LuxeMaroquineriePage;
